import { OnMouseDown } from "../dom-tools/EventListeners";

export class AudioHelper
{
  private static _audioContext:AudioContext;

  static onContextAvailable( onContext:( ac:AudioContext )=>void)
  {
    if ( this._audioContext )
    {
      onContext( this._audioContext );
      return;
    }
    
    let created = false;

    let createAudioContext = ()=>
    {
      if ( ! created )
      {
        console.log( "created context" );
        AudioHelper._audioContext = new AudioContext();
        created = true;
        onContext( AudioHelper._audioContext );
      }      
      
      OnMouseDown.remove( document.body, createAudioContext );
    }

    OnMouseDown.add( document.body, createAudioContext );


  }

  static play( path:string ):HTMLAudioElement
  {
    let audio = new Audio( path );
    audio.play();
    
    return audio;
  }

  static async decodeAudio( context:AudioContext, bytes:Uint8Array ):Promise<AudioBuffer>
  {
    return await context.decodeAudioData( bytes.buffer as ArrayBuffer );

  }
}